(function loadJQuery(callback) {
  if (typeof jQuery === 'undefined') {
    const script = document.createElement('script');
    script.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
    script.onload = function () {
      console.log('jQuery loaded.');
      if (callback) callback();
    };
    document.head.appendChild(script);
  } else {
    console.log('jQuery already available.');
    if (callback) callback();
  }
})(function () {
  // Your code that depends on jQuery here
  $(document).ready(function () {
    function initCustomSellingPlans() {
      const dropdown = document.querySelector('.rc-selling-plans__dropdown');    
      
      if (!dropdown || document.querySelector('.custom-selling-plan-options')) return;
    
      // Hide dropdown
      dropdown.style.display = 'none';

      const selectedRadio = document.querySelector('.rc-radio-group__options input[type="radio"]:checked');
      if (selectedRadio) {
        const selectedValue = selectedRadio.value;
        console.log('Initially selected value:', selectedValue);
        get_price_for_button(selectedValue);
        // Do something with selectedValue
      } else {
        console.log('No radio button is selected on load.');
      }

      $('span.rc-option__discount.rc_widget__option__discount').each(function(index, element) {
        if (!$(element).hasClass('discount_text_updated')) {
          // Get current text
          const currentText = $(element).text();

          // Modify text (example: append something)
          const updatedText = 'Save ' + currentText + ' on every order';

          // Set new text
          $(element).text(updatedText);
          $(element).addClass('discount_text_updated');
        }
      });
      
      // Create container
      const customContainer = document.createElement('div');
      customContainer.className = 'custom-selling-plan-options';
      dropdown.parentNode.insertBefore(customContainer, dropdown.nextSibling);
      // Create buttons from options
      Array.from(dropdown.options).forEach((option, index) => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'plan-option-button';
        btn.textContent = option.textContent;
        btn.dataset.value = option.value;

        // Add 'active' class to the first button
        if (index === 0) {
          btn.classList.add('active');
          dropdown.value = option.value;
          dropdown.dispatchEvent(new Event('change', { bubbles: true }));
        }
    
        btn.addEventListener('click', function () {
          dropdown.value = this.dataset.value;
          dropdown.dispatchEvent(new Event('change', { bubbles: true }));
    
          // Toggle active class
          document.querySelectorAll('.plan-option-button').forEach(b => b.classList.remove('active'));
          this.classList.add('active');
        });
    
        customContainer.appendChild(btn);

        const buttons_option = customContainer.querySelectorAll('.plan-option-button');
        customContainer.classList.remove('odd');
        customContainer.classList.remove('even');
        if (buttons_option.length % 2 === 0) {
          customContainer.classList.add('even');          
        } else {
          customContainer.classList.add('odd');         
        }
      });
    }

    //Display price on "Add to cart" button
    function get_price_for_button(selectedValue){
      var rc_price_selector = '.rc-option__price.rc_widget__price.rc_widget__price--' + selectedValue;
      var rc_price = $(rc_price_selector).text();

      if(selectedValue=='subsave'){
        var button_text = 'Subscribe & save, risk free';
      }else{
        var button_text = 'Buy once';
      }

      $('.product-block-buy-buttons form[action="/cart/add"] button.add-to-cart-btn span[x-text="addToCartText"]').text(button_text);
      $('.product-block-buy-buttons form[action="/cart/add"] button.add-to-cart-btn span[x-show="currentVariantAvailable"]').last().text(rc_price);
    }
    
    // Retry until Recharge dropdown is available
    const checkInterval = setInterval(() => {
      const target = document.querySelector('.rc-template__button-group');
      const dropdown = document.querySelector('.rc-selling-plans__dropdown');
      if (target && dropdown) {
        clearInterval(checkInterval);
        if($('.rc-radio-group__options label.rc-radio.rc-option__subsave rc-benefits').length == 0){
          var rc_benefits = '<rc-benefits exportparts="rc-benefits__list"><div class=" compact rc-benefits__list " part="rc-benefits__list"><ul><li><p>10% off all subscription orders</p></li><li><p>Fully flexible – skip or cancel anytime</p></li><li><p>Plenty of notice before each order</p></li></ul></div></rc-benefits>';
          $(rc_benefits).appendTo('.rc-radio-group__options label.rc-radio.rc-option__subsave');
        }
        $('.rc-selling-plans').appendTo('.rc-radio-group__options label.rc-radio.rc-option__subsave');
        initCustomSellingPlans();
      }
    }, 200);

    document.addEventListener('change', function(event) {
      if (event.target.matches('.variant-input input[type=radio]')) {
        if($('.custom-selling-plan-options').length > 0){
          $('.custom-selling-plan-options').remove();
          setTimeout(function(){
            initCustomSellingPlans();
          }, 500);
        }
      }
      if (event.target.matches('.rc-radio-group__options input[type=radio]')) {
        const selectedValue = event.target.value;
        get_price_for_button(selectedValue);
        console.log('Selected radio value:', selectedValue);
      }
    });
  });
});